
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.659 6.703H3.345c-.735 0-1.33.512-1.33 1.143v2.286c0 .63.595 1.143 1.33 1.143h9.313c.734 0 1.33-.512 1.33-1.143V7.846c0-.631-.596-1.143-1.33-1.143z","stroke":"#545C69","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.172 3.677c0-.8.648-1.448 1.448-1.448.914 0 1.753.317 2.415.847.66-.53 1.5-.847 2.414-.847a1.448 1.448 0 110 2.897.966.966 0 00-.966.965v5.794c0 .534.432.966.966.966a1.448 1.448 0 110 2.897 3.846 3.846 0 01-2.414-.847c-.662.53-1.501.847-2.415.847a1.448 1.448 0 110-2.897.966.966 0 00.966-.966V6.091a.966.966 0 00-.966-.965c-.8 0-1.448-.649-1.448-1.449z","fill":"#545C69"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.035 4.313L7.43 3.83a2.88 2.88 0 00-1.81-.635.483.483 0 100 .966c1.066 0 1.93.865 1.93 1.931v5.794a1.931 1.931 0 01-1.93 1.932.483.483 0 000 .965c.685 0 1.313-.237 1.81-.635l.604-.484.604.484a2.881 2.881 0 001.81.635.483.483 0 000-.965 1.931 1.931 0 01-1.932-1.932V6.091c0-1.066.865-1.931 1.932-1.931a.483.483 0 100-.966 2.88 2.88 0 00-1.81.635l-.604.484zm0-1.237a3.846 3.846 0 00-2.415-.847 1.449 1.449 0 100 2.897c.534 0 .966.432.966.965v5.794a.966.966 0 01-.966.966 1.448 1.448 0 100 2.897c.914 0 1.753-.317 2.415-.847.66.53 1.5.847 2.414.847a1.448 1.448 0 100-2.897.966.966 0 01-.966-.966V6.091c0-.533.432-.965.966-.965a1.449 1.449 0 000-2.897c-.914 0-1.753.317-2.414.847z","fill":"#fff"}})])
          )
        }
      }
    